import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  public extractUrlParams(): any {
    const paramsTab = location.search.slice(1).split('&');
    const params = {};

    for (let i = 0; i < paramsTab.length; i += 1) {
      const p = paramsTab[i].split('=');
      params[p[0]] = p[1];
    }

    return params;
  }
}
